var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorgraphic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 137,
  height: 156,
  viewBox: "0 0 137 156"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4d4c4d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m68.557 14.176-5.586 1.91-5.175 1.77-14.56 4.982h15.408l6.02-2.06 5.55-1.896 3-1.026 19.048-6.516 2.293 6.516 1.75 4.982h5.344l-1.751-4.982L95.376 5zm-50.533 17.29L0 37.63l18.024 51.256 5.05 14.364V88.056l-5.05-14.364-11.6-32.986 11.6-3.969 5.05-1.727v-5.274zm95.901 41.478 5.05 14.364 11.6 32.986-11.6 3.969-5.05 1.727v5.274l5.05-1.727L137 123.37l-18.024-51.256-5.05-14.364zM78.35 138.162l-14.563 4.982-19.048 6.516-2.293-6.516-1.75-4.982H35.35l1.751 4.982L41.624 156 79.2 143.144l14.562-4.982z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.947 138.07H24.053V23.93h90.894zM95.567 19H19v124h101V19zM115 13h5V0h-5zM124 24h13v-5h-13zM126.633 16 123 12.367 132.366 3 136 6.634z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49 45h39v-5H49zM39 69h61v-5H39zM63 94h37v-5H63zM38 94h15v-5H38zM38 118h31v-5H38z"
})), /*#__PURE__*/React.createElement("text", {
  fill: "#d12424",
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontSize: 27,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 86,
  y: 126
}, "X")))));
export default SvgErrorgraphic;